import React from "react";
import { updateNode } from "../../NodeUtils";

function ensureStyleObject(node) {
  if (!node.styles) node.styles = {};
  if (!node.styles.custom) node.styles.custom = {};
  if (!node.styles.custom.spacing) node.styles.custom.spacing = {};

  return node.styles.custom.spacing;
}
export function SpacingInspector({ page, setPage, result }) {
  const { sectionIndex, containerIndex, cardIndex, elementIndex } = result.path;

  const node =
    result.level === "section"
      ? page.sections[sectionIndex]
      : result.level === "container"
      ? page.sections[sectionIndex].contents[containerIndex]
      : result.level === "card"
      ? page.sections[sectionIndex].contents[containerIndex].cards[cardIndex]
      : page.sections[sectionIndex].contents[containerIndex].cards[cardIndex].elements[elementIndex];

 const spacing = ensureStyleObject(node);
  const update = (changes) => {
    const updatedNode = {
      ...node,
      styles: {
        ...node.styles,
        custom: {
          ...node.styles.custom,
          spacing: {
            ...spacing,
            ...changes,
          },
        },
      },
    };
    setPage(updateNode(page, node.id, updatedNode));
  };

const createField = (label, key, min = -200, max = 200) => (
  <div style={{ marginBottom: 12 }}>
    <label style={{ fontSize: 12 }}>{label}</label>

    <input
      type="range"
      min={min}
      max={max}
      value={spacing[key] ?? 0}
      onChange={(e) => update({ [key]: parseInt(e.target.value) })}
      style={{ width: "100%" }}
    />

    <div style={{ fontSize: 11, color: "#555" }}>
      {spacing[key] ?? 0}px
    </div>
  </div>
);


  return (
    <div style={{ marginTop: 16 }}>
      <h4>Spacing</h4>

      {/* Margin */}
      <h5>Margin</h5>
      {createField("Top", "marginTop")}
      {createField("Right", "marginRight")}
      {createField("Bottom", "marginBottom")}
      {createField("Left", "marginLeft")}

      {/* Padding */}
      <h5 style={{ marginTop: 12 }}>Padding</h5>
      {createField("Top", "paddingTop")}
      {createField("Right", "paddingRight")}
      {createField("Bottom", "paddingBottom")}
      {createField("Left", "paddingLeft")}

      <button
        style={{ marginTop: 12, width: "100%" }}
        onClick={() => update({})}
      >
        Reset
      </button>
    </div>
  );
}
